import React from 'react';
import { useProjectUrl } from '@atlassian/jira-horizontal-nav-common';
import { useIntl } from '@atlassian/jira-intl';
import { INSIGHT_TYPES, INSIGHT_TARGET_URLS } from '../../../common/constants';
import { InsightsWidget } from '../../../common/ui/widget';
import { messages } from './messages';

const DEFAULT_WHEN_NO_DATA = '-';

type Props = {
	value: number | null | undefined;
};

export const OpenPrInsightWidget: React.FC<Props> = ({ value }) => {
	const { formatMessage } = useIntl();

	const path = useProjectUrl({
		path: INSIGHT_TARGET_URLS.OPEN_PULL_REQUESTS,
	});
	return (
		<InsightsWidget
			title={formatMessage(messages.titleNonFinal)}
			value={value ?? DEFAULT_WHEN_NO_DATA}
			url={path}
			metricType={INSIGHT_TYPES.OPEN_PULL_REQUESTS}
		/>
	);
};
